<template>
  <div>
    <v-list-tile>
      <v-list-tile-avatar>
        <v-icon>person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="contact.name"></v-list-tile-title>
        <v-list-tile-sub-title v-html="contact.category"></v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>chat_bubble</v-icon>
      </v-list-tile-action>
    </v-list-tile>

              <!-- <v-divider inset></v-divider> -->
    <!-- <li><router-link to=:link >{{contact.full_name }} - {{contact.last_name}}</router-link></li> -->
  </div>
</template>

<script>
export default {
  props: ['contact'],
  computed: {
    full_name () {
      return this.contact.first_name + ' ' + this.contact.last_name
    },
    link: function () {
      return `/contacts/edit/${this.contact.id}`
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/contacts/Contact.vue